/* esm.sh - applesauce-core@5.2.0/dist/helpers/string */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/string.mjs";
